module.exports = __webpack_public_path__ + "img/CMHK_02_zhCn.8a03ce84.png";